import React, { useState } from 'react';
import { Navbar, Nav, Container, Button, NavDropdown } from 'react-bootstrap';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { FaHome, FaTools, FaEnvelope, FaQuoteRight, FaWater, FaCog } from 'react-icons/fa';
import LogoImage from './LogoImage';
import NikdipLogo from './NikdipLogo';

const Navigation = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <Navbar 
      bg="light" 
      expand="lg" 
      expanded={expanded} 
      className="shadow-sm sticky-top"
    >
      <Container>
        <Navbar.Brand as={RouterLink} to="/" className="navbar-brand d-flex align-items-center">
          {/* <LogoImage width="160" height="40" /> */}
          <NikdipLogo/>
          
        </Navbar.Brand>
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          onClick={() => setExpanded(expanded ? false : "expanded")}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link 
              as={RouterLink} 
              to="/" 
              onClick={handleNavClick}
              className={location.pathname === "/" ? "active" : ""}
            >
              <FaHome className="me-2" />Home
            </Nav.Link>
            <NavDropdown 
              title={<span><FaWater className="me-2" />Water Treatment</span>}
              id="water-treatment-dropdown"
              className={location.pathname.includes('water-softener') || location.pathname.includes('reverse-osmosis') || location.pathname.includes('boiler-water-treatment') || location.pathname.includes('cooling-tower-treatment') || location.pathname.includes('effluent-treatment') ? "active" : ""}
            >
              <NavDropdown.Item 
                as={RouterLink} 
                to="/water-softener" 
                onClick={handleNavClick}
                className={location.pathname === "/water-softener" ? "active" : ""}
              >
                <FaCog className="me-2" />Water Softener Systems
              </NavDropdown.Item>
              <NavDropdown.Item 
                as={RouterLink} 
                to="/reverse-osmosis" 
                onClick={handleNavClick}
                className={location.pathname === "/reverse-osmosis" ? "active" : ""}
              >
                <FaWater className="me-2" />Reverse Osmosis (RO)
              </NavDropdown.Item>
              <NavDropdown.Item 
                as={RouterLink} 
                to="/boiler-water-treatment" 
                onClick={handleNavClick}
                className={location.pathname === "/boiler-water-treatment" ? "active" : ""}
              >
                <FaCog className="me-2" />Boiler Water Treatment
              </NavDropdown.Item>
              <NavDropdown.Item 
                as={RouterLink} 
                to="/cooling-tower-treatment" 
                onClick={handleNavClick}
                className={location.pathname === "/cooling-tower-treatment" ? "active" : ""}
              >
                <FaWater className="me-2" />Cooling Tower Treatment
              </NavDropdown.Item>
              <NavDropdown.Item 
                as={RouterLink} 
                to="/effluent-treatment" 
                onClick={handleNavClick}
                className={location.pathname === "/effluent-treatment" ? "active" : ""}
              >
                <FaCog className="me-2" />Effluent Treatment (ETP)
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link 
              as={RouterLink} 
              to="/services" 
              onClick={handleNavClick}
              className={location.pathname === "/services" ? "active" : ""}
            >
              <FaTools className="me-2" />Services
            </Nav.Link>
            <Nav.Link 
              as={RouterLink} 
              to="/contact" 
              onClick={handleNavClick}
              className={location.pathname === "/contact" ? "active" : ""}
            >
              <FaEnvelope className="me-2" />Contact
            </Nav.Link>
          </Nav>
          <Button 
            variant="primary" 
            className="cta-button ms-lg-3"
            as={RouterLink}
            to="/contact"
            onClick={handleNavClick}
          >
            <FaQuoteRight className="me-2" />Request Quote
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
